/* eslint-disable @typescript-eslint/no-unused-vars */
import { FallBackModule } from 'src/components/common/modules/fallback-module';
import V2FloatingCta from 'src/components/common/modules/v2/v2-floating-cta';
import TestModule from 'src/components/common/modules/v2/test-module';
import v2GlobalHero from 'src/components/common/modules/v2/global-hero';
import MixedContent from 'src/components/common/modules/v2/mixed-content';
import PlaceFilterModuleV2 from 'src/components/common/modules/v2/place-filter';
import V2Content from 'src/components/common/modules/v2/content';
import LogoCarousel from 'src/components/common/modules/v2/logo-carousel';
import V2TextModule from 'src/components/common/modules/v2/v2-text-module';
import V2UnlockModule from 'src/components/common/modules/v2/v2-unlock-module';
import V2ContentTile from 'src/components/common/modules/v2/v2-content-tile';
import V2BookingWidget from 'src/components/common/modules/v2/v2-booking-widget';
import V2GalleryCarousel from 'src/components/common/modules/v2/v2-gallery-carousel';
import V2QuoteModule from 'src/components/common/modules/v2/v2-quote-module';
import V2TowColumnModule from 'src/components/common/modules/v2/v2-tow-column-module';
import V2TabbedContent from 'src/components/common/modules/v2/v2-tabbed-content';
import V2ProductIntegrationModule from 'src/components/common/modules/v2/v2-product-integration';
import V2FeaturedHotelPartnersModule from 'src/components/common/modules/v2/v2-featured-hotel-partners-module';
import v2ExpediaDeals from 'src/components/common/modules/v2/v2-expedia-deals';
import V2VideoGallery from 'src/components/common/modules/v2/v2-video-gallery';
import V2ImageContrast from 'src/components/common/modules/v2/v2-image-contrast';
import V2FeaturedArticle from 'src/components/common/modules/v2/v2-featured-article';
import V2FixtureDeals from 'src/components/common/modules/v2/v2-fixture-deals';
import V2HeroVideoPlayer from 'src/components/common/modules/v2/v2-hero-video-player';
import V2ImageQuote from 'src/components/common/modules/v2/v2-image-quote';
import V2AmbientVideoModule from 'src/components/common/modules/v2/v2-ambient-video-module';
import V2IconModule from 'src/components/common/modules/v2/v2-icon-module';
import V2ArticlePanel from 'src/components/common/modules/v2/v2-article-panel';
import V2ArticleSideRail from 'src/components/common/modules/v2/v2-article-side-rail';
import V2TabbedMapModule from 'src/components/common/modules/v2/v2-tabbed-map-module';
import V2ImageModule from 'src/components/common/modules/v2/v2-image-module';
import V2BrandImageGallery from 'src/components/common/modules/v2/v2-brand-image-gallery';
import V2MapModule from 'src/components/common/modules/v2/v2-map-module';
import V2ListicleModule from 'src/components/common/modules/v2/v2-listicle-module';
import V2ThemeModule from 'src/components/common/modules/v2/v2-theme-module';
import V2ThreeCardImage from 'src/components/common/modules/v2/v2-three-card-image';
import V2FeaturedHotelDeals from 'src/components/common/modules/v2/v2-featured-hotel-deals';
import V2VideoModule from 'src/components/common/modules/v2/v2-video-module';
import V2CanadaInteractiveMapModule from 'src/components/common/modules/v2/v2-canada-interactive-map-module';

type ModulesType = {
  [key: string]: () => any;
};

// V2 Modules Import Here...
const v2Modules: ModulesType = {
  v2GlobalHero: () => v2GlobalHero,
  v2HeroCinemaModule: () => V2HeroVideoPlayer,
  v2MixedContentListing: () => MixedContent,
  v2IntroductionModule: () => V2Content,
  v2LogoCarouselModule: () => LogoCarousel,
  v2TextModule: () => V2TextModule,
  //v2IntroductionModule: () => TestModule,
  v2FeaturedHotelPartnersModule: () => V2FeaturedHotelPartnersModule,
  v2UnlockModule: () => V2UnlockModule,
  v2ContentTileModule: () => V2ContentTile,
  v2GalleryCarouselModule: () => V2GalleryCarousel,
  v2FilterModule: () => PlaceFilterModuleV2,
  v2BookingWidget: () => V2BookingWidget,
  v2ProductIntegrationModule: () => V2ProductIntegrationModule,
  v2QuoteModule: () => V2QuoteModule,
  v2PhotoQuoteModule: () => V2ImageQuote,
  v2TabbedContentModule: () => V2TabbedContent,
  v2TwoColumnTileModule: () => V2TowColumnModule,
  v2TabbedDealsModule: () => v2ExpediaDeals,
  v2VideoGalleryTileModule: () => V2VideoGallery,
  v2ImageContrastModule: () => V2ImageContrast,
  v2FeaturedArticleModule: () => V2FeaturedArticle,
  v2fixtureDealsModule: () => V2FixtureDeals,
  v2ArticlePanelModule: () => V2ArticlePanel,
  v2AmbientVideoModule: () => V2AmbientVideoModule,
  v2FloatingCtaModule: () => V2FloatingCta,
  v2IconModule: () => V2IconModule,
  v2SideRailModule: () => V2ArticleSideRail,
  v2TabbedMapModule: () => V2TabbedMapModule,
  v2ListicleModule: () => V2ListicleModule,
  v2ImageModule: () => V2ImageModule,
  v2BrandImageGalleryModule: () => V2BrandImageGallery,
  v2MapModule: () => V2MapModule,
  v2ThemeModule: () => V2ThemeModule,
  v2ThreeTileBannerModule: () => V2ThreeCardImage,
  v2HotelDealsModule: () => V2FeaturedHotelDeals,
  v2VideoModule: () => V2VideoModule,
  v2InteractiveMapModule: () => V2CanadaInteractiveMapModule,
  default: () => FallBackModule,
};

export default v2Modules;